import API_URL from '../../constants/url'
import fetchNetworkUtil from '../../../../utils/network/fetch'

export async function deleteApi ({
  endpoint,
  data,
  jwt
}) {
  const response = await fetchNetworkUtil(`${API_URL}${endpoint}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`
    },
    method: 'DELETE',
    body: JSON.stringify(data)
  })
  if (!response.ok) {
    throw (
      await response.json()
    )
  }
  return response.json()
}
